import { render, staticRenderFns } from "./ContractAdd.vue?vue&type=template&id=0971e65e&scoped=true"
import script from "./ContractAdd.vue?vue&type=script&lang=js"
export * from "./ContractAdd.vue?vue&type=script&lang=js"
import style0 from "./ContractAdd.vue?vue&type=style&index=0&id=0971e65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971e65e",
  null
  
)

export default component.exports